import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "error",
  styleUrls: ["./error.style.scss"],
  templateUrl: "./error.template.html",
  encapsulation: ViewEncapsulation.None,
  host: {
    class: "error-page container",
  },
  standalone: true,
  imports: [FormsModule, ButtonModule],
})
export class ErrorComponent {
  router: Router;

  constructor(router: Router) {
    this.router = router;
  }

  searchResult(): void {
    this.router.navigate(["/app", ""]);
  }
}
